import { ListBox, Table } from '@flos/react-ui';
import { type RowInformation } from '../../../config/flavourConfig';
import { getInsuranceSumsCoverableDetailsConfig } from '../utils/coverableDetailsInsuranceSumsConfig';
import { type CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import TableRow from '../../../shared_components/TableRow/TableRow';
import { useHippoText } from '../../../hooks/useHippoText';
import useWindowSize from '../../../hooks/useWindowSize';

const CoverableDetailsInsuranceSums = ({
    coverable
}: {
    coverable: CoverableDTO;
}): React.JSX.Element => {
    const { isMobileDevice } = useWindowSize();
    const listBoxIsOpen = isMobileDevice;
    const getHippoText = useHippoText();
    const componentProperties = getInsuranceSumsCoverableDetailsConfig(coverable, getHippoText);
    const coverableProperties = componentProperties?.rowsInformation.filter(
        (rowInfo) => !rowInfo.hidden
    );

    const groupCoverablePropertiesByCategoryType = (
        rows: RowInformation[]
    ): Record<string, RowInformation[]> => {
        return rows.reduce((acc: Record<string, RowInformation[]>, item) => {
            const categoryType = item.categoryType ?? 'category1';
            if (!acc[categoryType]) {
                acc[categoryType] = [];
            }
            acc[categoryType].push(item);
            return acc;
        }, {});
    };

    const groupedData = coverableProperties
        ? groupCoverablePropertiesByCategoryType(coverableProperties)
        : {};

    if (!coverable || !coverableProperties || coverableProperties.length === 0) {
        return <></>;
    }
    return (
        <div className="u-spacing-inset-m--stretch-max">
            <ListBox title={componentProperties?.title ?? ''} isOpen={!listBoxIsOpen}>
                {[
                    ...Object.entries(groupedData).map(
                        ([category, items]: [string, RowInformation[]]) => (
                            <Table
                                key={category}
                                mobileDirection="horizontal"
                                className="u-spacing-stack-sm"
                            >
                                <Table.Body>
                                    {items.map((item: RowInformation, index: number) => (
                                        <TableRow key={item.key ?? index} rowInfo={item} />
                                    ))}
                                </Table.Body>
                            </Table>
                        )
                    )
                ]}
            </ListBox>
        </div>
    );
};

export default CoverableDetailsInsuranceSums;
